import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel the closure of my account',
    classicClosureAfter1Year:
      '\n\nWe look forward to welcoming you again, and wish you all the best!',
    delayBeforeClosure:
      'We will check that everything is in order and you will receive an email confirming the final closure of your account within 3 to 5 working days.',
    help: 'Some of your account features are suspended because you requested the closure of your account.',
    permanentClosure:
      '\n\nAfter this period, the closure of your account will be **final**.',
    stopActivity:
      '\n\nWe **wish you all the best** for your next projects. Don’t hesitate to come back and see us!',
    stopActivityAfter1Year:
      '\n\nWe wish you all the best for your next projects. We look forward to welcoming you back.',
    titleClassicAfter1Year: 'Thank you for the journey together!',
    titleClassicBefore1Year:
      'We have received your request to close your account',
    titleStopActivity: 'Thank you for your trust!',
  },
  fr: {
    cancel: 'Annuler la clôture de mon compte',
    classicClosureAfter1Year:
      '\n\nNous vous accueillerons à nouveau avec plaisir, **bonne continuation !**',
    delayBeforeClosure:
      'Nous allons vérifier que tout est en règle et vous recevrez un e-mail vous confirmant la clôture définitive de votre compte sous 3 à 5 jours ouvrés.',
    help: 'Certaines fonctionnalités de votre compte sont suspendues car vous avez demandé la clôture de votre compte.',
    permanentClosure:
      '\n\nAprès ce délai, la fermeture de votre compte sera **définitive**.',
    stopActivity:
      '\n\nNous vous **souhaitons le meilleur** pour vos prochains projets. N’hésitez pas à revenir nous voir !',
    stopActivityAfter1Year:
      '\n\nNous vous **souhaitons le meilleur** pour vos prochains projets. Nous serons ravis de vous accueillir à nouveau parmi nous.',
    titleClassicAfter1Year: 'Merci pour ce bout de chemin parcouru ensemble !',
    titleClassicBefore1Year:
      'Nous avons bien reçu votre demande de clôture de compte',
    titleStopActivity: 'Merci pour votre confiance !',
  },
});

export default locales;
